import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./css/Navbar.module.css";
import { Link, useNavigate } from "react-router-dom";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../redux/slices/languageSlice";
import { Badge } from "@mui/material";
import { useLocation } from "react-router-dom";
import logo from "../assets/logo_mm.png";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { setQuantity } from "../redux/slices/quantitySlice";

const Navbar: FunctionComponent = () => {
  const language = useSelector((state: any) => state.language.value);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("accessToken");
  const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
  const [totalQuantity, setTotalQuantity] = useState(
    cartItems.reduce(
      (acc: number, item: { quantity: number }) => acc + item.quantity,
      0
    )
  );

  const reduxState = useSelector((state: any) => state);

  useEffect(() => {
    dispatch(setQuantity(totalQuantity));
  }, [totalQuantity]);

  const handleLanguageChange = (event: SelectChangeEvent) => {
    dispatch(setLanguage(event.target.value));
  };

  const handleProfileClick = () => {
    if (isLoggedIn) {
      navigate("/admin/myaccount");
    } else {
      navigate("/login");
    }
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className={styles.mainContainer}>
      <Link to="/" className={styles.logo}>
        <img src={logo} />
      </Link>

      <div className={styles.menu}>
        <Link to="/">
          <span className={styles.menuItem}>
            {language === "EN" && "Home"}
            {language === "RO" && "Acasă"}
          </span>
        </Link>
        <Link to="/about">
          <span className={styles.menuItem1}>
            {language === "EN" && "About the author"}
            {language === "RU" && "Об авторе"}
            {language === "RO" && "Despre autoare"}
          </span>
        </Link>
        <div
          onClick={() =>
            location.pathname === "/consultation"
              ? scrollToSection("section8")
              : navigate("/consultation")
          }
        >
          <span className={styles.consultationMenuItem}>
            {language === "EN" && "1:1 Consultation"}
            {language === "RU" && "Консультация"}
            {language === "RO" && "Consultație 1:1"}
          </span>
        </div>
        <Link to="/contacts">
          {" "}
          <span className={styles.contactsMenuItem}>
            {language === "EN" && "Contacts"}
            {language === "RU" && "Контакты"}
            {language === "RO" && "Contacte"}
          </span>
        </Link>
      </div>

      <div className={styles.frame}>
        <div className={styles.languageSwitch}>
          <FormControl sx={{ paddingRight: "10px" }}>
            <Select
              sx={{
                color: "#517059",
                "& .MuiSelect-icon": {
                  color: "#517059",
                },
              }}
              className={styles.languageSwitchChild}
              value={language}
              onChange={handleLanguageChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem style={{ color: "#517059" }} value={"RO"}>
                RO
              </MenuItem>
              <MenuItem style={{ color: "#517059" }} value={"EN"}>
                EN
              </MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={styles.cart}>
          <Badge
            badgeContent={totalQuantity}
            color="primary"
            overlap="rectangular"
          >
            <div onClick={() => navigate("/cart")}>
              <svg
                width="22"
                height="24"
                viewBox="0 0 22 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.4656 7.55857C15.4656 8.13067 14.8148 8.59729 14.1549 8.59729C13.5041 8.59729 12.9575 8.13067 12.9575 7.55857V6.89509C12.9575 6.33003 13.5041 5.85457 14.1549 5.85457C14.8148 5.85457 15.4656 6.33003 15.4656 6.89509V7.55857ZM9.14677 7.55857C9.14677 8.13067 8.60019 8.59729 7.83703 8.59729C7.18622 8.59729 6.63968 8.13067 6.63968 7.55857V6.89509C6.63968 6.33003 7.18622 5.85457 7.83703 5.85457C8.60019 5.85457 9.14677 6.33003 9.14677 6.89509V7.55857ZM22 23.0509L20.8026 5.67443C20.6893 5.19988 20.2642 4.81494 19.8138 4.81494H2.28239C1.73583 4.81494 1.30971 5.19988 1.30971 5.67443L0 23.0509C0 23.3374 0.10424 23.5184 0.216588 23.7144C0.434199 23.9025 0.650819 24 0.971669 24H21.1326C21.5668 24 22 23.616 22 23.1484C22 23.0509 22 23.0509 22 23.0509ZM10.9959 1.70314C12.5233 1.70314 13.7206 2.74275 13.7206 4.06183H15.6822C15.6822 1.80068 13.6164 0 10.9959 0C8.49695 0 6.3178 1.80068 6.3178 4.06183H8.27935C8.27935 2.74275 9.47671 1.70314 10.9959 1.70314Z"
                  fill="#517159"
                />
              </svg>
            </div>
          </Badge>
          <PersonOutlineOutlinedIcon
            style={{ color: "#517159" }}
            onClick={handleProfileClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
